/**
 * Baixa o CSV de um relatório. Irmão do `downloadHtmlReport`, sem o `injectLogo`
 * — num CSV não há onde pendurar marca, e não deveria haver.
 *
 * **Não acrescentar BOM aqui.** O serializador do backend (`infra/report/csv.ts`)
 * já abre a string com `﻿`, que é o que faz o Excel em português reconhecer
 * UTF-8. Um segundo BOM aparece como `ï»¿` na primeira célula.
 *
 * O `charset=utf-8` no tipo do Blob é redundante com o BOM e fica de propósito:
 * quem abre o arquivo por um caminho que ignora o BOM ainda acerta a codificação.
 */
export function downloadCsvReport(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(url);
}
